// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { IRequestWithHeaderCpf, Types } from './types';

export function consultaCpfRequest(
	token: string,
	// payload: ConsultaCpfRequest,
	payload: IRequestWithHeaderCpf,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_CONSULTA_CPF_REQUEST,
		token,
		payload,
	};
}

export function consultaCpfSuccess(
	payload: IRequestWithHeaderCpf,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_CONSULTA_CPF_SUCCESS,
		payload,
	};
}

export function consultaCpfFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_CONSULTA_CPF_FAILURE,
		payload: null,
	};
}

export function consultaCpfClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_CONSULTA_CPF_CLEAR,
		payload: null,
	};
}
